import React from 'react';
import { useDispatch } from 'react-redux';

import { toastError, toastSuccess } from '@components/Toast';

import useSingleFileUpload from '@hooks/useSingleFileUpload';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { deleteProductDocument, uploadDocument } from '@services/commonService';
import { addSupplierMaterialDocument, removeDocById } from '@services/supplierOnboardingService';

import { printApiError } from '@utils/Util';

const UploadKeyProduct = ({ fieldName, setDocumentList, documentList, product }) => {
	const { readFile } = useSingleFileUpload();
	const dispatch = useDispatch();

	const onRemoveDocument = async (docId) => {
		try {
			dispatch(openLoader());
			if (fieldName === 'garmentsUpload' && product?.featureImageId === docId) {
				await deleteProductDocument(product.id, docId);
			}
			if (product?.featureImageId !== docId) {
				await removeDocById(docId);
			}
			setDocumentList([]);
			dispatch(closeLoader());
		} catch (e) {
			dispatch(closeLoader());
			printApiError(e);
		}
	};

	const renderTypeWiseDocuments = () => {
		if (documentList.length > 0) {
			return documentList?.map((item) => {
				return (
					<div key={`document_${item.id}`} className="file-editing">
						{item?.docUrl && (
							<img
								src={item.docUrl}
								alt=""
								onClick={() => window.open(item.docUrl, '_blank')}
							/>
						)}
						<div className="action-icon cursor-pointer" onClick={() => onRemoveDocument(item.id)}>
							<img src={`${process.env.PUBLIC_URL}/icons/trash.svg`} alt="" width={20} />
						</div>
					</div>
				);
			});
		}
	};

	const handleFileChange = async (e) => {
		try {
			const files = e.target.files;
			if (!files) {
				toastError('No files selected!');
				return;
			}
			const readFilePromises = Array.from(files).map((file) =>
				readFile(file).then((base64Str) => {
					return {
						documentDTO: {
							name: file.name,
							docMimeType: file.type,
							documentType:
								fieldName === 'garmentsUpload' ? 'REFERENCE_IMAGE' : 'MATERIAL_FEATURE_IMAGE',
							base64Str
						}
					};
				})
			);

			const data = await Promise.all(readFilePromises);
			if (fieldName === 'garmentsUpload') {
				const doc = await uploadDocument(data[0].documentDTO);
				setDocumentList([doc]);
			} else {
				const response = await addSupplierMaterialDocument(data[0].documentDTO);
				setDocumentList([response]);
			}
			toastSuccess('Updated successfully');
		} catch {
			toastError('Failed to upload file!');
		}
	};

	return (
		<div className="col-md-12 pr-2">
			<div className="upload-img mb-2">
				<div className="file-uploader small upload-design-image mb-4 mb-sm-0">
					<label htmlFor={fieldName} className="drag-upload" />
					<input
						type="file"
						className="file-upload d-none"
						id={fieldName}
						name={fieldName}
						onClick={(e) => (e.target.value = null)}
						multiple={false}
						accept={'image/*'}
						onChange={handleFileChange}
					/>
				</div>
				{renderTypeWiseDocuments()}
			</div>
		</div>
	);
};

export default UploadKeyProduct;
